(function () {
  'use strict';

  var quieto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (quieto) {
    document.documentElement.classList.add('motion-off');
    return;
  }
  document.documentElement.classList.add('motion-on');

  var soporteScrollTimeline = CSS && CSS.supports && CSS.supports('animation-timeline: view()');

  /* ---- 1. Entrada escalonada: opacidad, desenfoque y desplazamiento ---- */

  var grupos = [
    { sel: '.sec-head .eyebrow', modo: 'bloque' },
    { sel: '.sec-head p', modo: 'bloque' },
    { sel: '.goal', modo: 'grupo' },
    { sel: '.pcard', modo: 'grupo' },
    { sel: '.tp-card', modo: 'grupo' },
    { sel: '.usp .item', modo: 'grupo' },
    { sel: '.gallery .card', modo: 'grupo' },
    { sel: '.testi', modo: 'grupo' },
    { sel: '.split > div', modo: 'bloque' },
    { sel: '.pchip', modo: 'grupo' },
    { sel: '.faq-item', modo: 'grupo' },
    { sel: '.hero-copy > *', modo: 'secuencia' },
    { sel: '[data-m-group] > *', modo: 'grupo' },
    { sel: '[data-m-seq] > *', modo: 'secuencia' }
  ];

  var io = new IntersectionObserver(function (entradas) {
    entradas.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('m-in');
      io.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });

  grupos.forEach(function (g) {
    var nodos = document.querySelectorAll(g.sel);
    var previo = null, indice = 0;
    nodos.forEach(function (n) {
      if (n.closest('.pmarquee') || n.closest('.marquee') || n.closest('.trust')) return;
      n.classList.add('m-up');
      if (g.modo === 'grupo') {
        var padre = n.parentElement;
        if (padre !== previo) { indice = 0; previo = padre; }
        n.style.setProperty('--m-delay', (indice % 6) * 70 + 'ms');
        indice++;
      } else if (g.modo === 'secuencia') {
        n.style.setProperty('--m-delay', indice * 90 + 'ms');
        indice++;
      }
      io.observe(n);
    });
  });

  /* ---- 2. Titulares que se revelan palabra por palabra ---- */

  document.querySelectorAll('[data-m-words], .sec-head h2, .split h2, .protocols-sub').forEach(function (h) {
    // El CSS que revela las palabras cuelga de [data-m-words]: si el titular llegó
    // acá por selector y no por atributo, hay que ponérselo o queda invisible.
    h.setAttribute('data-m-words', '');
    var partes = [];
    Array.prototype.forEach.call(h.childNodes, function (nodo) {
      if (nodo.nodeType === 3) {
        nodo.textContent.split(/(\s+)/).forEach(function (t) {
          if (!t.trim()) { partes.push(document.createTextNode(t)); return; }
          var s = document.createElement('span');
          s.className = 'm-word';
          s.textContent = t;
          partes.push(s);
        });
      } else if (nodo.nodeType === 1) {
        var envoltura = document.createElement('span');
        envoltura.className = 'm-word';
        envoltura.appendChild(nodo.cloneNode(true));
        partes.push(envoltura);
      }
    });
    h.textContent = '';
    partes.forEach(function (p) { h.appendChild(p); });
    var palabras = h.querySelectorAll('.m-word');
    palabras.forEach(function (p, i) { p.style.setProperty('--m-delay', i * 55 + 'ms'); });
    new IntersectionObserver(function (e, obs) {
      if (!e[0].isIntersecting) return;
      h.classList.add('m-in');
      obs.disconnect();
    }, { threshold: 0.3 }).observe(h);
  });

  /* ---- 3. Parallax y escala ligados al scroll ---- */

  var capas = [];
  document.querySelectorAll('[data-m-parallax]').forEach(function (el) {
    capas.push({ el: el, fuerza: parseFloat(el.dataset.mParallax) || 0.12, tipo: 'shift' });
  });
  document.querySelectorAll('[data-m-zoom]').forEach(function (el) {
    // El escalado va al contenido, no al marco: así el overflow del marco lo recorta
    // y no empuja el ancho de la página.
    var destino = el.firstElementChild || el;
    capas.push({ el: destino, fuerza: parseFloat(el.dataset.mZoom) || 0.08, tipo: 'zoom' });
  });

  var pendiente = false;
  function pintarCapas() {
    var vh = window.innerHeight;
    capas.forEach(function (c) {
      var r = c.el.getBoundingClientRect();
      if (r.bottom < -200 || r.top > vh + 200) return;
      var centro = r.top + r.height / 2;
      var p = (centro - vh / 2) / vh;          // -1 arriba, +1 abajo
      if (c.tipo === 'shift') {
        c.el.style.transform = 'translate3d(0,' + (p * c.fuerza * -100).toFixed(2) + 'px,0)';
      } else {
        var esc = 1 + Math.max(0, 1 - Math.abs(p)) * c.fuerza;
        c.el.style.transform = 'scale(' + esc.toFixed(4) + ')';
      }
    });
    pendiente = false;
  }
  function pedirPintado() {
    if (pendiente) return;
    pendiente = true;
    requestAnimationFrame(pintarCapas);
  }
  if (capas.length) {
    pintarCapas();
    window.addEventListener('scroll', pedirPintado, { passive: true });
    window.addEventListener('resize', pedirPintado);
  }

  /* ---- 4. Cifras que cuentan al aparecer ---- */

  document.querySelectorAll('[data-m-count]').forEach(function (el) {
    var destino = parseFloat(el.dataset.mCount);
    var sufijo = el.dataset.mSuffix || '';
    var prefijo = el.dataset.mPrefix || '';
    new IntersectionObserver(function (e, obs) {
      if (!e[0].isIntersecting) return;
      obs.disconnect();
      var t0 = null, dur = 1400;
      function paso(t) {
        if (!t0) t0 = t;
        var k = Math.min(1, (t - t0) / dur);
        var suave = 1 - Math.pow(1 - k, 3);
        var v = destino * suave;
        el.textContent = prefijo + (destino % 1 ? v.toFixed(1) : Math.round(v).toLocaleString('es')) + sufijo;
        if (k < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    }, { threshold: 0.5 }).observe(el);
  });

  /* ---- 5. Encabezado que se contrae al bajar ---- */

  var head = document.querySelector('header');
  if (head) {
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      head.classList.toggle('is-compact', y > 40);
    }, { passive: true });
  }

  window.__motionScrollTimeline = soporteScrollTimeline;
})();
